module.exports = __webpack_public_path__ + "img/x9.e764ceb5.jpg";